angular
  .module('package-management.module', [
    'ui.router'
  ]);
